var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ch3 class=\"bad_request_header\"\u003ESorry, but we couldn't find information for your request\u003C\u002Fh3\u003E";;return pug_html;};
module.exports = template;